import React from 'react';

import routePaths from 'config/routes';
import { NextPage } from 'next';
import redirectTo from 'services/redirectTo';
import LoginConsumer from 'src/components/login/consumer/LoginConsumer';
import { ReduxPageContext } from 'src/store';
import { config } from 'config/config';
import { PlatformEnum } from 'src/shared/enums';

const { INDEX } = routePaths;
const { CON_SPAIN } = PlatformEnum;

const LoginPage: NextPage = (): JSX.Element => {
  return (
    <div className="Login-component-container">
      <LoginConsumer />
    </div>
  );
};

LoginPage.getInitialProps = async (ctx: ReduxPageContext): Promise<any> => {
  const user = ctx.store.getState().auth.user;
  const platform = config.APP.PLATFORM;
  let location = INDEX;

  if (user) {
    if (ctx.query?.campaign) {
      location = `${INDEX}?campaign=${ctx.query.campaign}`;
    }
    if (ctx.query?.pregnancy !== 'true' || platform !== CON_SPAIN) redirectTo(location, ctx);
  }
};

export default LoginPage;
